<div class="summary__head">
  <span class="summary__eyebrow">{{ heading() }}</span>
  <span class="summary__count">
    <strong>{{ store.cards().length }}</strong>
    {{ store.cards().length === 1 ? 'banco' : 'bancos' }} ·
    <strong>{{ approvedCount() }}</strong>
    {{ approvedCount() === 1 ? 'aprovado' : 'aprovados' }}
    @if (showDealCount()) {
      · <strong>{{ dealCount() }}</strong> {{ dealCount() === 1 ? 'deal' : 'deals' }}
    }
  </span>
</div>

<ol class="summary__stages" aria-label="Bancos por etapa">
  @for (item of stages(); track item.stage) {
    <li
      class="summary__stage"
      [class]="'summary__stage summary__stage--' + item.tone"
      [class.summary__stage--empty]="item.count === 0">
      <span class="summary__label">{{ item.label }}</span>
      <span class="summary__number">{{ item.count }}</span>
      @for (total of item.totals; track total.currency) {
        <span class="summary__value">
          {{ total.currency }} {{ total.value | vaultFormatCurrency: 0 }}
        </span>
      } @empty {
        <span class="summary__value">—</span>
      }
    </li>
  }
</ol>
